import { mutatorAction } from "satcheljs";
import { setItem } from "owa-local-storage";
import getMyOutlookViewState from "../store/myOutlookViewState";

export const setMyOutlookFullPageShowingMutator: (isShowing: boolean) => void = mutatorAction("setMyOutlookFullPageShowingMutator", (isShowing: boolean): void => {
    getMyOutlookViewState().isFullPageShowing = isShowing;
});

export const setMyOutlookSectionHiddenMutator: (hidden: boolean) => void = mutatorAction("setMyOutlookSectionHiddenMutator", (hidden: boolean): void => {
    getMyOutlookViewState().isSectionHidden = hidden;
    setItem(self, "owa-personal-os-section-hidden", hidden ? "true" : "false");
});
